import { PageOrientation, QualioContentSection, QualioContentType } from '../components/shared/CKEditor/models';
import { Section } from '../types/section';
import { TemplateDetail } from '../types/templateDetail';

export function sortSection(sections: Section[]): Section[] {
  return sections?.sort((s1, s2) => s1.position - s2.position);
}

export function prepareSections(sections: Section[]): QualioContentSection[] {
  return (sections ?? []).map((section) => {
    return {
      attachments: null,
      content: section.content,
      id: section.id,
      position: section.position,
      title: section.title,
      type: section.type,
    };
  });
}

export function prepareContent(templateDetail: TemplateDetail) {
  return {
    content_type: QualioContentType.Template,
    id: templateDetail.id,
    orientation: PageOrientation.Portrait,
    sections: prepareSections(sortSection(templateDetail.sections)),
  };
}
